import { array, func, number, oneOfType, string } from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import HrbTranslate from '../../../components/language/HrbTranslate';
import EmdashText from '../../../components/library/common/EmdashText';
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren';
import InternalLink from '../../../router/InternalLink';
import ProductActions from '../../../store/productRedux';

const ActivationCodes = props => {

    const { productId, taxYear, clientId, activationCodes, getActivationCodes } = props

    useEffect(() => {
        if (productId && taxYear) {
            getActivationCodes(taxYear, productId, clientId);
        }
    }, [productId, taxYear])

    let codes = activationCodes || []
    let rafCode = codes.filter(c => c.couponType && c.couponType === 'RAF')[0]
    let presaleCode = codes.filter(d => d.couponType && d.couponType === 'PRE')[0]
    let presaleCodeLink = presaleCode ? `/presales/${presaleCode.id}/year/${taxYear}` : ''

    return (
        <Fragment>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <h4><HrbTranslate text='ReturnInfo.Headers.ActivationCodes' /></h4>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey='ReturnInfo.Labels.ReferAFriendCode'
                        loading={!activationCodes}>
                        {rafCode ?
                            <p className='p1 medium-weight'>{rafCode.code}</p> :
                            <p className='p1 medium-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey='ReturnInfo.Labels.PresaleCode'
                        loading={!activationCodes}>
                        {presaleCode ?
                            <InternalLink to={presaleCodeLink} useLinkBehavior>{presaleCode.code}</InternalLink> :
                            <p className='p1 medium-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                </div>
            </div>
        </Fragment>)
}

const mapStateToProps = (state) => {
    return {
        lang: state.layout.lang,
        activationCodes: state.product.activationCodes
    };
};

const mapDispatchToProps = (dispatch) => ({
    getActivationCodes: (taxYear, viewModelId, clientId) => dispatch(ProductActions.getActivationCodes(taxYear, viewModelId, clientId))
})

ActivationCodes.propTypes = {
    activationCodes: array,
    getActivationCodes: func,
    productId: oneOfType([number, string]),
    taxYear: oneOfType([number, string]),
    clientId: oneOfType([number, string])
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivationCodes);
